import { UserCampaignManagementAPIClient } from '@studyportals/campaign-management-api-interface';

const campaignManagementApiUrl = webpackDefinitions.VUE_APP_CAMPAIGN_MANAGEMENT_API_URL;

const userCampaignManagementAPIClient = new UserCampaignManagementAPIClient(campaignManagementApiUrl);

export default userCampaignManagementAPIClient;
